export default __webpack_public_path__ + "static/bridgephase-light-6897d619d26e3865c81da82de84c24cf.svg";